<script setup>
import {onMounted, ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import moment from "moment";
import router from "@/router/index.js";
import YTOrderState from "@/components/YTOrderState/index.vue"
import {listOrder} from "@/api/order/order.js";
import {storeList} from "@/api/post/post.js";
import {orderStateEnum} from "@/enum/orderStateEnum.js";

/*初次加载*/
onMounted(async () => {
  await handleSearch()
  await handleGetPost()
})

/*搜索功能*/
// 驿站枚举
const store = ref([])
// 订单状态枚举
const stateEnum = ref(orderStateEnum)
// 表单数据
const formData = reactive({
  goodsTypes: ["PHYSICAL_ITEM", "VIRTUAL_ITEM"],
  keyword: null,
  time: [],
  storeId: null,
  orderId: null,
  orderState: null,
  startDate: null,
  endDate: null,
  storeType: "STORE"
});
// 表单锚点
const ruleFormRef = ref()
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    // 处理订单时间、驿站id
    formData.storeId = cachePost.storeId ? cachePost.storeId : null;
    formData.startDate = formData.time[0] ? moment(formData.time[0]).format("YYYY-MM-DD") : null;
    formData.endDate = formData.time[1] ? moment(formData.time[1]).format("YYYY-MM-DD") : null;
    // 搜索实物商品
    const res = await listOrder(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.keyword = null
  formData.time = []
  formData.storeId = null
  formData.orderId = null
  formData.orderState = null
  formData.startDate =  null
  formData.endDate = null
  pagePost.value = 1
  totalPost.value = 0
  cachePost.storeId = null
  cachePost.storeName = null
  handleSearch('btnSearch')
}

/*获取驿站列表信息*/
// 翻页信息：当前页数、当前页条目数、总条目数
const pagePost = ref(1)
const pageSizePost = ref(5)
const totalPost = ref(0)
const postLoading = ref(false)
const cachePost = reactive({
  storeName: null,
  storeId: null
})
// 获取驿站列表
const handleGetPost = async () => {
  postLoading.value = true
  let param = {
    page: pagePost.value,
    pageSize: pageSizePost.value
  }
  const res = await storeList(param, {name: null})
  store.value = []
  store.value = res.list
  totalPost.value = Number(res.total)
  postLoading.value = false
}
// 处理选择驿站
const handleSelectPost = (e) => {
  const post = store.value.find(res => res.storeId === e)
  cachePost.storeName = post.name
  cachePost.storeId = e
}
// 驿站列表翻页
const handleChangePostPage = () => {
  handleGetPost()
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '订单编号', key: 'orderNo', nowrap: true },
  { title: '驿站', key: 'storeName', nowrap: true },
  { title: '状态', key: 'state', nowrap: true },
  { title: '创建时间', key: 'orderTime', nowrap: true },
  { title: '操作', key: 'controls', width: "100px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*操作栏功能*/
// 获取详情信息
const getDetail = (info) => {
  router.push({path: "/editPostOrder", query: {orderId: info.orderId,}})
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 0">
    <el-form
        ref="ruleFormRef"
        style="max-width: 400px;text-align: left"
        :model="formData"
        label-width="auto"
        class="demo-ruleForm"
        status-icon
        label-position="top"
    >
      <el-form-item label="订单编号：" prop="keyword">
        <el-input v-model="formData.keyword" placeholder="请输入订单编号"></el-input>
      </el-form-item>
      <el-form-item label="订单时间：" prop="time">
        <el-date-picker
            v-model="formData.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
        />
      </el-form-item>
      <el-form-item label="驿站：" prop="storeId">
        <el-select :loading="postLoading" v-model="cachePost.storeId" placeholder="请选择驿站" style="width: 240px" @change="handleSelectPost">
          <el-option
              v-for="item in store"
              :key="item.storeId"
              :label="item.name"
              :value="item.storeId"
          />
          <template v-if="!loading && cachePost.storeId && !store.some(res => res.storeId === cachePost.storeId)" #header>
            当前已选：
            <el-option
                :label="cachePost.storeName"
                :value="cachePost.storeId"
            />
          </template>

          <template #footer>
            <div class="flex_center">
              <el-pagination
                  size="small"
                  background
                  layout="prev, pager, next"
                  :total="totalPost"
                  class="mt-4"
                  v-model:current-page="pagePost"
                  v-model:page-size="pageSizePost"
                  @current-change="handleChangePostPage"
              />
            </div>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态：" prop="orderState">
        <el-select v-model="formData.orderState" placeholder="请选择订单状态" style="width: 240px">
          <el-option
              v-for="item in stateEnum"
              :key="item.stateId"
              :label="item.stateName"
              :value="item.stateId"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <v-col cols="3">
      <v-row justify="start">
        <v-col class="flex_left" cols="6">
          <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('all', 'orderAdmin:view')">搜索</v-btn>
        </v-col>
        <v-col class="flex_left" cols="6">
          <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('all', 'orderAdmin:view')">重置</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:item.state="{item}">
            <YTOrderState :state="item.orderState"></YTOrderState>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="left">
                <v-icon icon="mdi-file-edit-outline" color="primary" size="small" @click="getDetail(item)" v-show="$handleHasBtnPermission('all', 'orderAdmin:edit')"></v-icon>
              </el-tooltip>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
::marker {
  content: none;
}
</style>